import { render } from "./SelfAssessmentV2Scale.vue?vue&type=template&id=1ca15714&scoped=true"
import script from "./SelfAssessmentV2Scale.vue?vue&type=script&lang=js"
export * from "./SelfAssessmentV2Scale.vue?vue&type=script&lang=js"

import "./SelfAssessmentV2Scale.vue?vue&type=style&index=0&id=1ca15714&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca15714"]])

export default __exports__